import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between w-100 py-3" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "grey--text text--darken-1 mb-0 mr-3" }
const _hoisted_4 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, { class: "pa-0" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milks, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_list_item, {
          key: item.milkId || index,
          class: "border-bottom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.minuteFormat(item.recordedAt)), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(`${_ctx.categoryToText(item.milkCategory)}  ${item.amount ? item.amount.value + 'cc' : '不明'}`), 1)
              ]),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                color: "red",
                onClick: ($event: any) => (_ctx.deleteItem(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-delete", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}